import QueryString from "qs"
import {
  GetShopsRequestDto,
  GetShopsResultDto,
  GetShopByIdResultDto,
  GetPricingListResultDto,
} from "../models/api/shopApiTypes"
import { api } from "./clientApi"

export function getShops(payload?: GetShopsRequestDto) {
  return new Promise<GetShopsResultDto>((resolve, reject) => {
    api
      .get("/Shops", {
        params: payload,
        paramsSerializer: (params) => QueryString.stringify(params, { arrayFormat: "repeat" }),
      })
      .then((data) => resolve(data.data))
      .catch((err) => reject(err))
  })
}

export function getShopById(shopId: string) {
  return new Promise<GetShopByIdResultDto>((resolve, reject) => {
    api
      .get(`/Shops/${shopId}`)
      .then((data) => resolve(data.data))
      .catch((err) => reject(err))
  })
}

export function getShopPricingList(shopId: string) {
  return new Promise<GetPricingListResultDto>((resolve, reject) => {
    api
      .get(`Shops/${shopId}/pricingList`)
      .then((data) => resolve(data.data))
      .catch((err) => reject(err))
  })
}
